var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          staticClass: "sl-modal",
          attrs: {
            value: _vm.open,
            id: "details-modal",
            maximized: _vm.maximized,
            "content-css": {
              width: "1200px",
              maxWidth: "100%",
              minHeight: "85vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.onClose()
            }
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    [
                      _c("q-icon", {
                        attrs: { name: _vm.moduleIcon[_vm.module] }
                      }),
                      _vm.mode === "add"
                        ? _c("span", [_vm._v("Add " + _vm._s(_vm.title))])
                        : _vm._e(),
                      _vm.mode === "edit"
                        ? _c("span", [
                            _vm._v("Edit " + _vm._s(_vm.title) + " Details")
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._t("header-options"),
                  _c("q-icon", {
                    staticClass: "gt-sm",
                    attrs: { size: "20px", name: "filter_none" },
                    nativeOn: {
                      click: function($event) {
                        _vm.toggleMaximized()
                      }
                    }
                  }),
                  _c("q-icon", {
                    attrs: { name: "clear" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClose($event)
                      }
                    }
                  })
                ],
                2
              ),
              _vm.module === "users" ? _c("user-details") : _vm._e(),
              _vm.module === "students" ? _c("student-details") : _vm._e(),
              _vm.module === "courses" ? _c("course-details") : _vm._e(),
              _vm.module === "classes" ? _c("class-details") : _vm._e(),
              _vm.module === "orders" ? _c("order-details") : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }